import { styled as o } from "styled-components";
import { Theme as r } from "../../../../styles/themes/index.js";
import { MediaQuery as i } from "../../../../styles/variables.js";
import { CommentBadge as e } from "../CommentBadge/index.js";
const p = o.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  word-break: break-word;
  background-color: rgb(${r.colors.Juliet}, 0.7);
  border-radius: 8px;
  padding: 8px;

  & > img {
    max-width: 100%;
    display: block;
  }

  @media ${i.SCREEN_MD_UP} {
    background-color: rgb(${r.colors.Hotel});
    & > img {
      max-width: 500px;
    }
  }
`;
o(e)`
  margin-bottom: 8px;
`;
const l = o.div`
  margin-top: 8px;
  img {
    display: block;
  }
`;
export {
  p as Container,
  l as ContentWrapper
};
